import React from "react";
import { ModeRendererProps } from "./types";

// VASARELY × DA VINCI: Renaissance rationality meets modern optical logic
// Golden ratio grids, vitruvian geometry, transparent layers
export function VasarelyDaVinciMode({ brand }: ModeRendererProps) {
  const phi = 1.618; // Golden ratio

  return (
    <g>
      {/* Vitruvian circle and square */}
      <g transform="translate(397 540)">
        <circle cx="0" cy="0" r="280" fill="none" stroke={brand.aqua} strokeWidth="3" opacity="0.6" />
        <rect x="-198" y="-198" width="396" height="396" fill="none" stroke={brand.violet} strokeWidth="3" opacity="0.6" />
        
        {/* Golden ratio spiral grid */}
        {Array.from({ length: 8 }).map((_, i) => {
          const size = 200 / Math.pow(phi, i);
          const offset = i * 20 - 70;
          return (
            <rect
              key={i}
              x={offset - size / 2}
              y={offset - size / 2}
              width={size}
              height={size}
              fill="none"
              stroke={i % 2 === 0 ? brand.amber : brand.aqua}
              strokeWidth="2"
              opacity={0.7 - i * 0.05}
            />
          );
        })}

        {/* Anatomical proportion lines */}
        <line x1="-280" y1="0" x2="280" y2="0" stroke={brand.white} strokeWidth="1" opacity="0.4" strokeDasharray="4 2" />
        <line x1="0" y1="-280" x2="0" y2="280" stroke={brand.white} strokeWidth="1" opacity="0.4" strokeDasharray="4 2" />
        
        {/* Diagonal perspective lines */}
        {[-1, 1].map((dir) =>
          [-1, 1].map((dir2) => (
            <line
              key={`${dir}-${dir2}`}
              x1="0"
              y1="0"
              x2={dir * 280}
              y2={dir2 * 280}
              stroke={brand.violet}
              strokeWidth="1"
              opacity="0.3"
              strokeDasharray="6 3"
            />
          ))
        )}

        {/* Optical distortion circles (Vasarely effect) */}
        {Array.from({ length: 12 }).map((_, i) => {
          const r = 30 + i * 22;
          const distort = Math.sin(i * 0.5) * 8;
          return (
            <ellipse
              key={i}
              cx={distort}
              cy={-distort * 0.5}
              rx={r}
              ry={r * (1 + Math.sin(i * 0.3) * 0.15)}
              fill="none"
              stroke={i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber}
              strokeWidth="1.5"
              opacity={0.5}
            />
          );
        })}

        {/* Geometric nodes at golden ratio points */}
        {[0, 90, 180, 270].map((angle) => {
          const rad = (angle * Math.PI) / 180;
          const r = 198; // Square corner distance
          return (
            <circle
              key={angle}
              cx={Math.cos(rad) * r}
              cy={Math.sin(rad) * r}
              r="6"
              fill={brand.amber}
              opacity="0.8"
            />
          );
        })}
      </g>

      {/* Mathematical notation overlay */}
      <text x="397" y="120" textAnchor="middle" fontFamily="serif" fontSize="14" fill={brand.white} opacity="0.5">
        φ = 1.618... (golden ratio)
      </text>
    </g>
  );
}
